import React from "react";
import { useState } from "react";

const Services = () => {
   const [expandedCard, setExpandedCard] = useState(null);

  // Array of service data including short and expanded descriptions
  const services = [
    {
      id: 1,
      title: 'Full Truckload (FTL)',
      image: `${process.env.PUBLIC_URL}/assets/images/service/service-img-07.jpg`,
      shortDescription: 'Direct, dedicated transport using dry van, reefer, flatbed, or step-deck trailers for high-volume, time critical loads.',
      icon: 'bi bi-truck text-dark fs-1',
      expandedDescription: (
        <>
          <p>Secure single-trailer transport tailored to your shipment's schedule—from dock to dock. Ideal for high-volume, high-priority loads, FTL ensures:</p>
          <ul>
            <li>Faster transit with non-stop point-to-point delivery</li>
            <li>Minimized handling to reduce damage risk</li>
            <li>Access to dry van, reefer, flatbed, and step-deck trailers within our vetted carrier network</li>
            <li>Integrated coordination of scheduling, tracking, claims, and documentation</li>
          </ul>
        </>
      ),
    },
    {
      id: 2,
      title: 'Less-than-Truckload (LTL)',
      image: `${process.env.PUBLIC_URL}/assets/images/service/service-img-02.jpg`,
      shortDescription: 'Efficient partial-load shipping using pup or double trailers consolidated and cost-effective for pallet sized freight.',
      icon: 'bi bi-box-seam text-dark fs-1',
      expandedDescription: (
        <>
          <p>Ship partial loads and significantly lower costs by sharing space. Benefits include:</p>
          <ul>
            <li>Savings through consolidation with other shippers</li>
            <li>Efficient routing across dense carrier networks</li>
            <li>Perfect for smaller payloads (1-6 pallets) using pup or double trailers for responsiveness</li>
          </ul>
        </>
      ),
    },
    {
      id: 3,
      title: 'Intermodal & Drayage Services',
      image: `${process.env.PUBLIC_URL}/assets/images/service/service-img-03.png`,
      shortDescription: 'Short haul drayage links ports or rail terminals to inland hubs effortlessly bridging intermodal gaps in the supply chain.',
      icon: 'bi bi-train-freight-front text-dark fs-1',
      expandedDescription: (
        <>
          <p>Blend efficiency and sustainability with seamless mode transitions—whether by road, rail, or sea. Features include:</p>
          <ul>
            <li>Drayage—short-haul container moves between ports, rail ramps, and distribution centers, vital for intermodal chains</li>
            <li>Container-based intermodal shipments optimized for cost-saving and reduced handling risks</li>
            <li>Equipment compatibility for LCL, FCL, and chassis-based drayage operations</li>
          </ul>
        </>
      ),
    },
    {
      id: 4,
      title: 'LCL (Less Than Container Load)',
      image: `${process.env.PUBLIC_URL}/assets/images/service/service-img-04.png`,
      shortDescription: 'Flexible container shipping—pay only for the space you need, ideal for small volume international freight.',
      icon: 'bi bi-boxes text-dark fs-1',
      expandedDescription: (
        <>
          <p>Perfect for small-volume international shipments. Offers:</p>
          <ul>
            <li>Shipping by “pay only for what you use” container space</li>
            <li>Cost-effective & flexible ocean freight—ideal for businesses needing scalability</li>
            <li>Helpful for industries testing new markets or requiring agile shipment planning</li>
          </ul>
        </>
      ),
    },
    {
      id: 5,
      title: 'Overweight & Specialized Services (LTL)',
      image: `${process.env.PUBLIC_URL}/assets/images/service/service-img-05.png`,
      shortDescription: 'Specialized trailers (e.g. flatbed, lowboy) and permitting for oversized, overweight freight transported safely and legally.',
      icon: 'bi bi-truck-flatbed text-dark fs-1',
      expandedDescription: (
        <>
          <p>Handle non-standard loads with specialized care:</p>
          <ul>
            <li>Flatbed, step-deck, or lowboy trailers equipped for oversized and overweight freight</li>
            <li>Safe handling for site-specific deliveries and heavy-lift operations</li>
            <li>Expertise in securing necessary permits and coordinating specialized routing safely</li>
          </ul>
        </>
      ),
    },
    {
      id: 6,
      title: 'Hazmat (Hazardous Materials) Transport',
      image: `${process.env.PUBLIC_URL}/assets/images/service/service-img-15.png`,
      shortDescription: 'Fully compliant with regulations using certified drivers and proper containment for safe hazmat transport.',
      icon: 'bi bi-exclamation-triangle text-dark fs-1',
      expandedDescription: (
        <>
          <p>Transport hazardous shipments safely and compliantly:</p>
          <ul>
            <li>Compliant with 49 FR, IMDG, and IATA standards for hazmat drayage and transport</li>
            <li>Specialized equipment—reinforced containers, tankers, spill containment solutions</li>
            <li>Hazmat-certified drivers trained for strict safety protocols and emergency response</li>
          </ul>
        </>
      ),
    },
    {
      id: 7,
      title: '3PL Warehousing  and  Custom Solutions',
      image: `${process.env.PUBLIC_URL}/assets/images/service/service-img-07.png`,
      shortDescription: 'Scalable warehousing, pick-pack fulfillment, packaging, and cross-dock services integrated with your freight equipment.',
      icon: 'bi bi-gear text-dark fs-1',
      expandedDescription: (
        <>
          <p>Flexible logistics support tailored to your operations:</p>
          <ul>
            <li>Scalable warehousing, pick-and-pack, cross-docking, and fulfillment services</li>
            <li>Value-added processing like labeling, packaging, and inventory management</li>
            <li>Smooth integration with trailer-based distribution (dry van, reefer, flatbed)</li>
          </ul>
        </>
      ),
    },
    {
      id: 8,
      title: 'Customs Clearance & Customs Management',
      image: `${process.env.PUBLIC_URL}/assets/images/service/service-img-08.png`,
      shortDescription: 'Comprehensive handling of customs documentation, tariff classification, and compliance for seamless cross border shipments.',
      icon: 'bi bi-file-earmark-text text-dark fs-1',
      expandedDescription: (
        <>
          <p>Ensure smooth international shipping with expert regulatory support:</p>
          <ul>
            <li>End-to-end handling of customs documentation, tariff classification, and compliance</li>
            <li>Coordination for LCL, FCL, and intermodal shipments with door-to-door visibility</li>
          </ul>
        </>
      ),
    },
  ];

  // Function to toggle expanded state for a specific card
  const toggleExpand = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  return (
    <div className="page-wrapper">
      {/* Header Main Area */}
      <header className="site-header header-style-1">
        <div className="pbmit-title-bar-wrapper1">
          <div className="container">
            <div className="pbmit-title-bar-content">
              <div className="pbmit-title-bar-content-inner">
                <div className="pbmit-tbar">
                  <div className="pbmit-tbar-inner container">
                    <h1 className="pbmit-tbar-title">Services</h1>
                  </div>
                </div>
                <div className="pbmit-breadcrumb">
                  <div className="pbmit-breadcrumb-inner">
                    <span>
                      <a title="" href="#" className="home">
                        <span> TRACKLINE XR</span>
                      </a>
                    </span>
                    <span className="sep">
                      <i className="pbmit-base-icon-angle-right"></i>
                    </span>
                    <span>
                      <span className="post-root post post-post current-item">
                        Services
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Title Bar End*/}
      </header>
      {/* Header Main Area End Here */}

      <div className="page-content">
        {/* Services Start */}
       <section className="section-lg">
  <div className="container">
    <div className="row">
      <div className="col-12 text-center mb-5">
        <h2 className="pbmit-title">Our Services</h2>
      </div>
    </div>

    <div className="pbmit-element-posts-wrapper row justify-content-center">
      {services.map((service, index) => (
        <article className="pbmit-service-style-1 col-md-4 mb-4" key={service.id}>
          <div className="pbminfotech-post-item">
            <div className="pbmit-box-content-wrap">
              <div className="pbmit-service-image-wrapper">
                <div className="pbmit-featured-img-wrapper">
                  <div className="pbmit-featured-wrapper">
                    <img src={service.image} className="img-fluid" alt="" />
                  </div>
                </div>
                <div className="pbmit-service-btn-wrapper">
                  <a className="pbmit-service-btn" href="#" title={service.title}>
                    <span className="pbmit-button-icon">
                      <i className="pbmit-base-icon-angle-right"></i>
                    </span>
                  </a>
                </div>
              </div>

              <div className="pbmit-content-box">
                <div className="pbminfotech-box-number">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <div className="pbmit-serv-cat"></div>
                <h3 className="pbmit-service-title">
                  <a href="#">{service.title}</a>
                </h3>
                <div className="pbmit-service-description">
                  {expandedCard === service.id ? service.expandedDescription : <p>{service.shortDescription}</p>}
                  <button
                    className="pbmit-read-more-btn"
                    onClick={() => toggleExpand(service.id)}
                  >
                    {expandedCard === service.id ? 'Read Less' : 'Read More'}
                  </button>
                </div>
                <div className="pbmit-service-icon">
                  <i className={service.icon}></i>
                </div>
              </div>
            </div>
          </div>
        </article>
      ))}
    </div>
  </div>
</section>


        
        {/* Services end */}
        <section className="section-xl">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <h2 className="pbmit-title">Why Our Services Stand Out</h2>
              </div>
            </div>
            <div className="row">
              {/* Card 1 */}
              <article className="pbmit-miconheading-style-5 col-md-6 col-lg-4 col-xl-3">
                <div className="pbmit-ihbox-style-5">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-wrap">
                      <div className="pbmit-ihbox-contents">
                        <h2 className="pbmit-element-title">Tailored Solutions</h2>
                        <div className="pbmit-heading-desc">
                          Whether you're shipping domestically or across borders, we
                          tailor the perfect logistics strategy for your needs.
                        </div>
                      </div>
                      <div className="pbmit-ihbox-icon">
                        <div className="pbmit-ihbox-icon-wrapper pbmit-icon-type-icon">
                          <i className="bi bi-gear-fill fs-1"></i>
                        </div>
                      </div>
                    </div>
                    <div className="pbmit-btn-wrap">
                      <div className="pbmit-ihbox-btn">
                        <a className="pbmit-button-inner" href="#">
                          <span className="pbmit-button-icon"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </article>

              {/* Card 2 */}
              <article className="pbmit-miconheading-style-5 col-md-6 col-lg-4 col-xl-3">
                <div className="pbmit-ihbox-style-5">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-wrap">
                      <div className="pbmit-ihbox-contents">
                        <h2 className="pbmit-element-title">
                          Carrier Matching & Reliability
                        </h2>
                        <div className="pbmit-heading-desc">
                          We match you with reliable, vetted carriers to ensure timely,
                          damage-free delivery.
                        </div>
                      </div>
                      <div className="pbmit-ihbox-icon">
                        <div className="pbmit-ihbox-icon-wrapper pbmit-icon-type-icon">
                          <i className="bi bi-truck fs-1"></i>
                        </div>
                      </div>
                    </div>
                    <div className="pbmit-btn-wrap">
                      <div className="pbmit-ihbox-btn">
                        <a className="pbmit-button-inner" href="#">
                          <span className="pbmit-button-icon"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </article>

              {/* Card 3 */}
              <article className="pbmit-miconheading-style-5 col-md-6 col-lg-4 col-xl-3">
                <div className="pbmit-ihbox-style-5">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-wrap">
                      <div className="pbmit-ihbox-contents">
                        <h2 className="pbmit-element-title">Transparent Operations</h2>
                        <div className="pbmit-heading-desc">
                          From quote to delivery, we keep you informed with tracking,
                          updates, and responsive support.
                        </div>
                      </div>
                      <div className="pbmit-ihbox-icon">
                        <div className="pbmit-ihbox-icon-wrapper pbmit-icon-type-icon">
                          <i className="bi bi-eye-fill fs-1"></i>
                        </div>
                      </div>
                    </div>
                    <div className="pbmit-btn-wrap">
                      <div className="pbmit-ihbox-btn">
                        <a className="pbmit-button-inner" href="#">
                          <span className="pbmit-button-icon"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </article>

              {/* Card 4 */}
              <article className="pbmit-miconheading-style-5 col-md-6 col-lg-4 col-xl-3">
                <div className="pbmit-ihbox-style-5">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-wrap">
                      <div className="pbmit-ihbox-contents">
                        <h2 className="pbmit-element-title">
                          Scalable, All-in-One Logistics
                        </h2>
                        <div className="pbmit-heading-desc">
                          From FTL to intermodal, 3PL, and customs, get complete logistics under one roof
                        </div>
                      </div>
                      <div className="pbmit-ihbox-icon">
                        <div className="pbmit-ihbox-icon-wrapper pbmit-icon-type-icon">
                          <i className="bi bi-layers-fill fs-1"></i>
                        </div>
                      </div>
                    </div>
                    <div className="pbmit-btn-wrap">
                      <div className="pbmit-ihbox-btn">
                        <a className="pbmit-button-inner" href="#">
                          <span className="pbmit-button-icon"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Services;